import { render, staticRenderFns } from "./HouseHistory.vue?vue&type=template&id=0beee8aa&scoped=true&"
import script from "./HouseHistory.vue?vue&type=script&lang=js&"
export * from "./HouseHistory.vue?vue&type=script&lang=js&"
import style0 from "./HouseHistory.vue?vue&type=style&index=0&id=0beee8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beee8aa",
  null
  
)

component.options.__file = "HouseHistory.vue"
export default component.exports